export const subtitles = {
    "1": {
        "startTime": 0.0,
        "endTime": 4.5,
        "transcript": "Arnat makut mat'umek mikelngurnek kenkiyaramek",
        "translation": "How these women love these children"
    },
    "2": {
        "startTime": 5.4,
        "endTime": 14.0,
        "transcript": "Arcaqerluteng mikelnguuluki-llu aulukituameng waken tua-i yuurtellratnek ayagluki.",
        "translation": "Because they especially take care of them when they're children starting from when they're born."
    },
    "3": {
        "startTime": 14.5,
        "endTime": 27.0,
        "transcript": "Taumek ilii tua-i nallunritlermikun Lucy-m makunek mikelngurnek kenkiyaramek",
        "translation": "As much as Lucy knows about some of those, how to love these children"
    },
    "4": {
        "startTime": 27.5,
        "endTime": 37.0,
        "transcript": "Nallunritellni aturluku elliin ellminek umyuarteqlermikun qanruciiqaakut.",
        "translation": "She will speak to us about what she knows and what she personally thinks."
    },
    "5": {
        "startTime": 38.6,
        "endTime": 45.0,
        "transcript": "Makut tua-i nallunritlerpegun mikelnguut, mikelngurnek kenkiyaramek",
        "translation": "What you know about these children, how to love these children"
    },
    "6": {
        "startTime": 46.5,
        "endTime": 56.0,
        "transcript": "Tua-i arnanun yuurtellratnek ayagluki pitukait aulukaqamegteki yuurtellratnek ayagluki.",
        "translation": "Women take care of them starting from birth when they take care of them from birth."
    },
    "7": {
        "startTime": 56.5,
        "endTime": 63.0,
        "transcript": "Kenkut'seng mikelngurnun tua-i qanrutkeqerniaran nallunritetacirpegun.",
        "translation": "Please talk about what you know concerning their love for children."
    },
    "8": {
        "startTime": 73.0,
        "endTime": 75.0,
        "transcript": "Mikelngurnek-wa tua-i imumi",
        "translation": "[Taking care of] children a long time ago"
    },
    "9": {
        "startTime": 75.3,
        "endTime": 83.0,
        "transcript": "Au͡gkut aulukestemta aulukellruitkut ca tamalkuan qanrutekluku.",
        "translation": "Our caretakers cared for us by talking about everything."
    },
    "10": {
        "startTime": 85.0,
        "endTime": 92.0,
        "transcript": "Aipangllemteńek ayagluta qalaruquratullruitkut ca nalluvkarpek'naku.",
        "translation": "They would always talk to us starting when we married letting us know everything [that they could]."
    },
    "11": {
        "startTime": 92.5,
        "endTime": 100.5,
        "transcript": "Tuaten-llu irniangekumta aulukillerkamteńek mikelngurnek qanrutetullruitkut.",
        "translation": "They also talked about how to take care of children if we were to bear children."
    },
    "12": {
        "startTime": 101.0,
        "endTime": 108.8,
        "transcript": "Au͡gkut tang aulukesteput waten ayuqellrunrilnguut watuam nalliicetun.",
        "translation": "You see, our caretakers were not how we are these days."
    },
    "13": {
        "startTime": 109.9,
        "endTime": 115.9,
        "transcript": "Kass'anek tangyuitellruukut amllernek, canek-llu akinek tangyuunata.",
        "translation": "We didn't see a lot of Caucasians, nor did we see things like money."
    },
    "14": {
        "startTime": 116.0,
        "endTime": 120.0,
        "transcript": "Akimek tangerrnaciarumallruunga wiinga ak'anun.",
        "translation": "I didn't see money for a long time."
    },
    "15": {
        "startTime": 120.3,
        "endTime": 129.8,
        "transcript": "Tua-i-wa enuqitellriarulua anglillruama tua-i tamakunek canek piyuitellrulrianga.",
        "translation": "Because I grew up poor, I didn't have those kinds of things."
    },
    "16": {
        "startTime": 130.5,
        "endTime": 137.0,
        "transcript": "Cali aanama aulukellra wangnun maa-i nalluyagucuitaqa.",
        "translation": "Neither do I forget how my mother took care of me."
    },
    "17": {
        "startTime": 137.7,
        "endTime": 140.0,
        "transcript": "Umyuaqelaraqa cakneq.",
        "translation": "I remember it clearly."
    },
    "18": {
        "startTime": 141.5,
        "endTime": 145.0,
        "transcript": "Waten aulukellruanga aanama:",
        "translation": "My mother took care of me like this:"
    },
    "19": {
        "startTime": 146.0,
        "endTime": 153.0,
        "transcript": "Neqkaq man'a, neqkaq-llu man'a, meq-llu man'a anglanitekevkallrunritaa.",
        "translation": "She didn't allow me to be frivolous with food, food or water."
    },
    "20": {
        "startTime": 153.1,
        "endTime": 158.0,
        "transcript": "Tau͡gaam elliin cikiutni kiingan tua-i.",
        "translation": "What she gave was the only [stuff I ingested]."
    },
    "21": {
        "startTime": 158.1,
        "endTime": 162.0,
        "transcript": "Una wani atam tua-i iluka elisngauq waniwa.",
        "translation": "You see, my stomach is used to it now."
    },
    "22": {
        "startTime": 162.1,
        "endTime": 165.0,
        "transcript": "Ayuqucimnek qanrutqataramci.",
        "translation": "I'm going to tell youpl what I'm like."
    },
    "23": {
        "startTime": 165.4,
        "endTime": 172.0,
        "transcript": "Qam'um iluma elisngaa avaken ayaglua neryaraqa.",
        "translation": "My stomach inside is used to how I've always eaten."
    },
    "24": {
        "startTime": 172.8,
        "endTime": 180.7,
        "transcript": "Nurrluku, una wani erenrem qukallra nurrluku imirngaunaku man'a call' man'a erneq tekilluku waniw'.",
        "translation": "I will not fill it before noon even to this very day now."
    },
    "25": {
        "startTime": 181.4,
        "endTime": 185.6,
        "transcript": "Atakutallerkaq-llu nurrluku cali imirngaunaku qamna.",
        "translation": "Neither will I fill it before it's time for dinner."
    },
    "26": {
        "startTime": 186.0,
        "endTime": 190.5,
        "transcript": "Tua-i elisngaluni cailkakun neramliyuunii.",
        "translation": "It's used to me not eating randomly."
    },
    "27": {
        "startTime": 190.6,
        "endTime": 195.4,
        "transcript": "Waten tang imumi ayuqellrunrilnguut au͡gkut yuut ciuqliit.",
        "translation": "The first people back then were not like this."
    },
    "28": {
        "startTime": 195.5,
        "endTime": 200.4,
        "transcript": "Cailkakun neramliurayuitut neryarat akulaitni",
        "translation": "They did not eat randomly in between meals"
    },
    "29": {
        "startTime": 200.5,
        "endTime": 205.5,
        "transcript": "Neryarat ukuullruameng pingayun: unuakumi yuurqerluteng,",
        "translation": "Because there were these three [set] meals: drinking something in the morning,"
    },
    "30": {
        "startTime": 207.5,
        "endTime": 212.4,
        "transcript": "Tua-i-ll' wani nutaan apiatami erenrem qukaani nerluteng neqpignek.",
        "translation": "And then at lunch at noon, they would finally eat real food."
    },
    "31": {
        "startTime": 212.5,
        "endTime": 216.5,
        "transcript": "Tua-i nerluta tua-i cunaw' aqsiluta tua-i tuani.",
        "translation": "We ate then and turned out to be full."
    },
    "32": {
        "startTime": 217.0,
        "endTime": 223.5,
        "transcript": "Aqsitnguksaitelaryaaqut-llu cikiuteput aanamteńek; cangimirrnaq'laryaaqellruut.",
        "translation": "And what our mothers gave us were not [entirely] filling; they would leave us wanting more."
    },
    "33": {
        "startTime": 224.4,
        "endTime": 227.5,
        "transcript": "Wani-llu atakumi tua-i atakutarluta.",
        "translation": "And we would eat dinner in the evening."
    },
    "34": {
        "startTime": 227.6,
        "endTime": 231.8,
        "transcript": "Tua-i-ll' kinguani ca igenqigtevkenaku unuakurvianun.",
        "translation": "And then after that, we wouldn't ingest anything else until morning."
    },
    "35": {
        "startTime": 232.0,
        "endTime": 237.0,
        "transcript": "Unugmi-llu elisngaluni iluvut meqsuyuunata unugmi.",
        "translation": "And our stomachs would be used to it, so we wouldn't be thirsty at night."
    },
    "36": {
        "startTime": 238.0,
        "endTime": 243.0,
        "transcript": "Unuakumi tau͡gaam tua-i uitaqamta carrarmek tua-i.",
        "translation": "Only in the morning would we [ingest] a little when we woke up."
    },
    "37": {
        "startTime": 243.5,
        "endTime": 252.9,
        "transcript": "Assaliarrluarmek-llu pikaitaqama wiinga taum aanama carraquinermek neqkuinermek cikiqatullruanga pikartuyiqellrunrilamta.",
        "translation": "And when my mother gave me a piece of pancake when I had nothing else, she would give me a little nibble because we didn't have a lot."
    },
    "38": {
        "startTime": 254.0,
        "endTime": 261.5,
        "transcript": "Tua-i-ll' tauna cikiukarii ilayuunaku ilangnaqsuunaku-llu.",
        "translation": "And I wouldn't add to or try to add to what little she gave."
    },
    "39": {
        "startTime": 262.5,
        "endTime": 266.5,
        "transcript": "Waten tang, yuum-wa tua-i man'a aturyugngakii.",
        "translation": "You see, a person can do this."
    },
    "40": {
        "startTime": 266.6,
        "endTime": 270.5,
        "transcript": "Maa-i-ll' makut kinguqlimta eliskunegteggu aturyugngaat.",
        "translation": "And if our descendants learn, they can do it."
    },
    "41": {
        "startTime": 272.4,
        "endTime": 281.8,
        "transcript": "Uuggun kiingan wiinga ilumkun tamana tua-i maa-i ciumurutaqa man'a erneq engelkarrluku nerlalqa.",
        "translation": "I am continuing that only with my stomach to this day through my eating habits."
    },
    "42": {
        "startTime": 283.8,
        "endTime": 291.7,
        "transcript": "Au͡gkut tau͡gken ilait cat tua-i makut tua-i allaurcaaquq auluklemni cat makut.",
        "translation": "However, some of those things are changing from what I've taken care of."
    },
    "43": {
        "startTime": 292.9,
        "endTime": 299.0,
        "transcript": "Tau͡gaam waten-llu tarrilluta nangengqaluta-llu iqemkarcecuitellruitkut.",
        "translation": "But, they wouldn't let us nibble as we walked around or were standing."
    },
    "44": {
        "startTime": 299.1,
        "endTime": 302.0,
        "transcript": "Nerqercecuitellruitkut nangengqaluta.",
        "translation": "They wouldn't not let us eat standing."
    },
    "45": {
        "startTime": 302.5,
        "endTime": 309.0,
        "transcript": "Waten-llu maa-i tangvalalrianga; ava-i-llam unuaq itrama uani tangvalrianga elpeceńek",
        "translation": "And I see this today too; and when I came in this morning, I watched youpl"
    },
    "46": {
        "startTime": 309.8,
        "endTime": 315.0,
        "transcript": "Kuuvvialrianek saskaq teguluku tua-i-ll' piyuangluteng.",
        "translation": "People drinking coffee take the cup and then walk around."
    },
    "47": {
        "startTime": 316.0,
        "endTime": 319.5,
        "transcript": "Kaaka elluarrluni tut'elartuq qamavet ilumun.",
        "translation": "Listen, does it really settle well inside?"
    },
    "48": {
        "startTime": 319.6,
        "endTime": 322.0,
        "transcript": "Tua-i-w' cimiutii maa-i man'a",
        "translation": "This is how it has changed"
    },
    "49": {
        "startTime": 322.7,
        "endTime": 326.5,
        "transcript": "Yuut au͡gkut ciuqliit alerquutiita cimiutekaa.",
        "translation": "How the instruction of those first people back then changed."
    },
    "50": {
        "startTime": 326.6,
        "endTime": 329.6,
        "transcript": "Itlemni unuaq tangvagamci tua-i.",
        "translation": "I watched youpl when I came in this morning."
    },
    "51": {
        "startTime": 330.8,
        "endTime": 335.4,
        "transcript": "Imiriqaarluni una yuk apelcirpek'nani pak'mumun",
        "translation": "After this person filled [a cup] without asking permission from above"
    },
    "52": {
        "startTime": 335.5,
        "endTime": 342.0,
        "transcript": "Tua-i imiriqaarluni tua-i-ll' ayagluni yuurqerluni piyualuni enenun-llu itraqluni.",
        "translation": "After he fills a cup, he goes, drinks as he walks, and goes into rooms."
    },
    "53": {
        "startTime": 342.1,
        "endTime": 345.8,
        "transcript": "Tua-i tang maa-i man'a cimiutekaa.",
        "translation": "You see, this is how it's changed."
    },
    "54": {
        "startTime": 346.3,
        "endTime": 351.5,
        "transcript": "Qanlalriaci tua-i au͡gkut yuut ciuqliit yuullrat cimirniluku.",
        "translation": "Youpl say that the life of the people back then has changed."
    },
    "55": {
        "startTime": 351.6,
        "endTime": 355.0,
        "transcript": "Maa-i cimiutiin ilakaat man'a.",
        "translation": "This is one of the changes."
    },
    "56": {
        "startTime": 355.3,
        "endTime": 367.0,
        "transcript": "Atam irniangamta-llu qurrellranun teq'urranun uqlautevkayuitellruat.",
        "translation": "When we bore children, you see, they didn't let their urine make a mess."
    },
    "57": {
        "startTime": 367.1,
        "endTime": 372.2,
        "transcript": "Terr'iliciqtaarluki irniaput aulukellrunritaput ciuqliit.",
        "translation": "We didn't take care of our first children with repeated diaper changing."
    },
    "58": {
        "startTime": 373.0,
        "endTime": 380.0,
        "transcript": "Maa-i ukaqvani terr'ilitaryaurtellruut mikelnguut Kass'alingan.",
        "translation": "Children started using diapers when Caucasians became numerous."
    },
    "59": {
        "startTime": 381.0,
        "endTime": 387.6,
        "transcript": "Wangkuta irniatullruukut pek'artellrat unugmi tamalkuan makyulluku.",
        "translation": "We took care of children by waking up with every little move they made."
    },
    "60": {
        "startTime": 388.5,
        "endTime": 391.5,
        "transcript": "Qessaniutullruukut irnialriani.",
        "translation": "We with children could not be lazy."
    },
    "61": {
        "startTime": 392.2,
        "endTime": 397.5,
        "transcript": "Mikelnguut-wa tua-i kenekngamteki kenkepiarluki auluktullruaput.",
        "translation": "Because we loved children, we took care of them with a lot of love."
    },
    "62": {
        "startTime": 397.6,
        "endTime": 402.0,
        "transcript": "Unitaayuunaki babysit-ayuunata-llu.",
        "translation": "We didn't leave them a lot and didn't babysit."
    },
    "63": {
        "startTime": 402.2,
        "endTime": 409.5,
        "transcript": "Wiinga-ll' waniwa irnillruyaaqua qula cetamanek cipluku.",
        "translation": "And now, I've had 14 children."
    },
    "64": {
        "startTime": 409.8,
        "endTime": 420.8,
        "transcript": "Au͡gkut qulen, ukut wani qulen enemni antellruanka ayayuunii hospital-aamun.",
        "translation": "Those ten, I gave birth to these ten in my home without going to the hospital."
    },
    "65": {
        "startTime": 421.5,
        "endTime": 424.5,
        "transcript": "Tua-i-llu ukut wani qulem cipnerit cetaman",
        "translation": "And then these four after the [first] ten"
    },
    "66": {
        "startTime": 426.0,
        "endTime": 437.5,
        "transcript": "Man'a temka qaillun ayuqngan nutaan wavet ayaglua ukut cetaman ancartularyaaqellruanka.",
        "translation": "Because my body was a little amiss, I finally went here [to the hospital] to give birth to these four."
    },
    "67": {
        "startTime": 437.6,
        "endTime": 442.7,
        "transcript": "Tau͡gaam ukut wani irnivigmi anellrunritut pingayun",
        "translation": "But these three were not born in the maternity wing"
    },
    "68": {
        "startTime": 442.8,
        "endTime": 448.7,
        "transcript": "Una tau͡gaam nangneqlikacaaq kinguqlikacaaq irnivigmun anellruuq.",
        "translation": "But this last youngest one was born in the maternity wing."
    },
    "69": {
        "startTime": 449.0,
        "endTime": 460.0,
        "transcript": "Tua-i-wa ak'anun nangtequmayuunii, nepliriiyuunii ak'anun",
        "translation": "You see, I did not suffer for long, nor was I in labor for long"
    },
    "70": {
        "startTime": 460.5,
        "endTime": 465.7,
        "transcript": "Nangteqnamek imumek irniam anellranek pillruama.",
        "translation": "Because I had already suffered to give birth."
    },
    "71": {
        "startTime": 466.0,
        "endTime": 469.8,
        "transcript": "Tua-i nallunrilkemnek qanertua.",
        "translation": "I'm talking about what I know."
    },
    "72": {
        "startTime": 469.9,
        "endTime": 474.0,
        "transcript": "Taum qingaqerraallemni aanama alerqulallruanga,",
        "translation": "When I was first pregnant, my mother instructed me,"
    },
    "73": {
        "startTime": 477.0,
        "endTime": 485.6,
        "transcript": "“Assirluten irnituyukuvet, assirluten-llu nepliriituyukuvet aka'nun-llu pivkenak",
        "translation": "“If you want to give birth without problems, and if you want to have a good laboring period that's not too long"
    },
    "74": {
        "startTime": 486.5,
        "endTime": 492.0,
        "transcript": "“Unugmi-llu erenrani-llu umyuarteqellren tamalkuan anlaqina ellamun.”",
        "translation": "“Every time you think of it, go outside at night and in the morning.”"
    },
    "75": {
        "startTime": 492.5,
        "endTime": 499.0,
        "transcript": "Tang tamakut asgurakevkenaki wangkuta alerquukaraput atullrukput.",
        "translation": "You see, we adhered to what instructions we had without doubting them."
    },
    "76": {
        "startTime": 502.0,
        "endTime": 503.5,
        "transcript": "Atutullrukput.",
        "translation": "We adhered to them."
    },
    "77": {
        "startTime": 503.6,
        "endTime": 510.0,
        "transcript": "Tua-i-llu mikelnguq yuurcan tua-i wangkuta aulukluku.",
        "translation": "And then when the child was born, we took care of him."
    },
    "78": {
        "startTime": 510.5,
        "endTime": 514.0,
        "transcript": "Aulukeqtarluku ayuqucirterluta aanamteńek.",
        "translation": "We took care of him with our mothers to instruct us."
    },
    "79": {
        "startTime": 514.5,
        "endTime": 520.0,
        "transcript": "Unugmi serr'illra tamalkuan qurrucirluku mikcuayaarmek anenerrayaaq.",
        "translation": "Every time the newborn child rustled from sleep, we had them urniate [in a waste container]."
    },
    "80": {
        "startTime": 520.7,
        "endTime": 527.0,
        "transcript": "Tuatnaurluku mecungcuunaku aci, kinerqurtelluku, uqlayuunata.",
        "translation": "We always did that, never wetting the bad, always keeping it dry, and we never made a mess."
    },
    "81": {
        "startTime": 528.0,
        "endTime": 534.0,
        "transcript": "Tua-i-llu wiinga tamaani pingama sass'at elicamki makut sass'artangan",
        "translation": "And when I started with that, when I learned [the ways of] clocks when clocks first came"
    },
    "82": {
        "startTime": 534.8,
        "endTime": 539.8,
        "transcript": "Sass'akun analallrat qurrlallrat-llu nallunrirluki.",
        "translation": "I learned when they defecated and urinated by the hours."
    },
    "83": {
        "startTime": 539.9,
        "endTime": 544.0,
        "transcript": "Tua-i aulukilallruunga nutaan.",
        "translation": "I truly took care [of children]."
    },
    "84": {
        "startTime": 544.1,
        "endTime": 550.5,
        "transcript": "Atam imkut aulukestemta aanamta qanrutetullrukaitkut",
        "translation": "You see, our caretakers, our mothers would tell us"
    },
    "85": {
        "startTime": 550.6,
        "endTime": 555.7,
        "transcript": "“Anglirikan qanpagatelaryaqunaku.",
        "translation": "“When [s]he grows up, do not shout at him."
    },
    "86": {
        "startTime": 556.0,
        "endTime": 559.8,
        "transcript": "“Inerqulaqiu erinan tapirpek'naku.",
        "translation": "“Admonish him without raising your voice."
    },
    "87": {
        "startTime": 560.0,
        "endTime": 563.7,
        "transcript": "“Tuaten pilaquvni niisngaciqaaten.",
        "translation": "“If you do that, [s]he will not obey you."
    },
    "88": {
        "startTime": 564.0,
        "endTime": 572.7,
        "transcript": "“Tua-i tau͡gken erinan tapirluku qastuluten-llu qatgulluku-llu pilaquvni",
        "translation": "“However, if you raise your voice and shout at him loudly"
    },
    "89": {
        "startTime": 573.4,
        "endTime": 576.7,
        "transcript": "“Tuaten mikelnguq assirluni yuungaituq.",
        "translation": "“That child will not live right."
    },
    "90": {
        "startTime": 577.0,
        "endTime": 581.0,
        "transcript": "“Pamaitarkauguq niicuitarkauluni-llu.”",
        "translation": "“He will be stubborn and disobedient.”"
    },
    "91": {
        "startTime": 582.5,
        "endTime": 588.8,
        "transcript": "Wiinga tang waten mat'umek nallunrilkemnek alerkuukaramnek qanelrianga.",
        "translation": "You see, I am talking about what instruction I had that I know."
    },
    "92": {
        "startTime": 592.0,
        "endTime": 599.8,
        "transcript": "Au͡gkut tua-i ava-i waten qanlalriit-wa tua-i, qanelrianek niitelalrianga:",
        "translation": "They would say back then, I hear people say this:"
    },
    "93": {
        "startTime": 600.5,
        "endTime": 606.0,
        "transcript": "“Yuut, yuullrat-gguq Yupiit cimirtuq maa-i.”",
        "translation": "“The life of Yupiit is changing now.”"
    },
    "94": {
        "startTime": 606.3,
        "endTime": 608.0,
        "transcript": "Ava-i cimiutait.",
        "translation": "That's how they've changed."
    },
    "95": {
        "startTime": 608.3,
        "endTime": 617.3,
        "transcript": "Atam ca tamalkuan qanruyutengqellrulria wangkutni; ayuqucirtuuterluni.",
        "translation": "You see, everything had traditional wisdom connected to it for us; it had instructions."
    },
    "96": {
        "startTime": 620.4,
        "endTime": 632.0,
        "transcript": "Iliini narurtaqamteki umyuarniurutetangqelartuq cali tamana qanruyun narurtellranek.",
        "translation": "When we disobeyed them sometimes, there is also regret when we disobey that traditional wisdom."
    },
    "97": {
        "startTime": 637.0,
        "endTime": 642.5,
        "transcript": "Tamaa-i tua-i nallunrita'arqemnek mikelnguliuryaramek kenkiyaramek mikelngurmek.",
        "translation": "That's what I know about taking care of children, loving children."
    },
    "98": {
        "startTime": 642.6,
        "endTime": 649.5,
        "transcript": "Yuum kenkekuniu mikelnguq tua-i tuaten kenekluku aulukarkaullinia.",
        "translation": "If a person loves a child, [s]he must take care of him with love like that."
    },
    "99": {
        "startTime": 649.6,
        "endTime": 653.5,
        "transcript": "Cali nalluvkarpek'naki picurlagnarqelriit.",
        "translation": "They must also have them know about what brings misfortune."
    },
    "100": {
        "startTime": 654.0,
        "endTime": 662.5,
        "transcript": "Kiaresngialutkai, iteqngqatkai nalluvkarpek'naki itercivigmelutekai.",
        "translation": "Let them know what will cause them shame, what will get them incarcerated, what will put them into jail."
    },
    "101": {
        "startTime": 663.8,
        "endTime": 669.0,
        "transcript": "Atam arcaqalriarulriit angayuqrulriani wangkuta irniaput.",
        "translation": "You see, our children are the most important for us parents."
    },
    "102": {
        "startTime": 670.3,
        "endTime": 674.8,
        "transcript": "Itercivigmun-llu ayautaqatki pitsqevkenani ilamta",
        "translation": "And if by chance one of our relatives is incarcerated"
    },
    "103": {
        "startTime": 675.5,
        "endTime": 684.5,
        "transcript": "Angayuqaagken elluarrlutek ilamegnek ilaliurciigaliteklarakek tamakut",
        "translation": "His parents cannot socialize well with their families because of that"
    },
    "104": {
        "startTime": 685.0,
        "endTime": 690.5,
        "transcript": "Elkenka-wa tua-i anglicallruamegnegenki, aulukellruamegenki.",
        "translation": "Because they2 raised them, because they2 took care of them."
    },
    "105": {
        "startTime": 691.4,
        "endTime": 694.8,
        "transcript": "Man'a tang tua-i cimiutii.",
        "translation": "You see, this is how [our lives] have changed."
    },
    "106": {
        "startTime": 695.0,
        "endTime": 704.0,
        "transcript": "Ava-i cimirniluku au͡gkut yuut yullret au͡gkut piciryarallrat cimirniluku tua-i qanlalriakut.",
        "translation": "We say that the traditions of those people back then have changed."
    },
    "107": {
        "startTime": 704.1,
        "endTime": 706.8,
        "transcript": "Tua-i nalluvkenaku-llu maa-i cimillra.",
        "translation": "We know that it has changed now."
    },
    "108": {
        "startTime": 707.0,
        "endTime": 714.6,
        "transcript": "Ava-i tua-i nallunrita'arqevceńek au͡g'umek ciuqlilirluku cimillret iliit.",
        "translation": "I just started off with what you know of one of the changes."
    },
    "109": {
        "startTime": 715.5,
        "endTime": 721.0,
        "transcript": "Tarrilluta wangkuta iluliurcecuitellruitkut.",
        "translation": "They didn't let us ingest anything as we wandered about."
    },
    "110": {
        "startTime": 721.7,
        "endTime": 728.4,
        "transcript": "Meqsukapiarangramta-llu nerrlemta kinguani egmian mermek cikiliyuitellruitkut.",
        "translation": "And even if we were very thirsty after we ate, they wouldn't give us water right away."
    },
    "111": {
        "startTime": 728.5,
        "endTime": 734.0,
        "transcript": "Tua-i-llu tua-i kinerluku qanerput ugaani meqsuum.",
        "translation": "And then our mouths would be dry because we were so thirsty."
    },
    "112": {
        "startTime": 735.0,
        "endTime": 738.9,
        "transcript": "Qat'riluni-llu nuak tamana.",
        "translation": "That saliva turned white."
    },
    "113": {
        "startTime": 739.0,
        "endTime": 745.0,
        "transcript": "Tuatnaaqan tau͡gaam tua-i mequinermek cikiqalallruitkut tua-i-llu tauna meq'erluku.",
        "translation": "Only when that happened, they would give us a little water and then we drank that."
    },
    "114": {
        "startTime": 745.5,
        "endTime": 752.0,
        "transcript": "Cangimirterpangramta-llu ilavkenaku ilavkayuilatgu.",
        "translation": "And even when we really wanted more, we wouldn't add to it because they wouldn't let us."
    },
    "115": {
        "startTime": 753.5,
        "endTime": 757.4,
        "transcript": "Neryarat atanqurluki. Tua-i elisngaluku.",
        "translation": "We waited for meals. We were used to it."
    },
    "116": {
        "startTime": 757.5,
        "endTime": 768.0,
        "transcript": "Wii tua-i waniw' tamana aulukutellra aanamnek iluma kiimi tua-i maligtaa, elisngaa.",
        "translation": "My stomach only knows and is used to how my mother took care of me."
    },
    "117": {
        "startTime": 768.1,
        "endTime": 773.5,
        "transcript": "Elilluku cailkakun neryarat avatiitni meyuunani.",
        "translation": "It got used to not drinking anything outside of meals."
    },
    "118": {
        "startTime": 777.0,
        "endTime": 784.5,
        "transcript": "Au͡gna ava-i qalarqurallren mumigcugyaaqaqa Kass'acetun qalarcuilngurnun.",
        "translation": "I would like to translate what you just said into English for those who do not speak [Yup'ik]."
    },
    "119": {
        "startTime": 785.0,
        "endTime": 789.0,
        "transcript": "Ava-i-llu qanrutaqa terr'ilitangqessuitellruut mikelnguut.",
        "translation": "I also just said that children didn't have diapers."
    },
    "120": {
        "startTime": 789.3,
        "endTime": 792.0,
        "transcript": "Tamaavet elliluki auluksuitellruaput.",
        "translation": "We didn't put them in those as we took care of them."
    },
    "121": {
        "startTime": 792.1,
        "endTime": 799.0,
        "transcript": "Tua-i tau͡gaam murilkurluki tua-i qurrlerkait cailkamun pivkanritengnaqluki.",
        "translation": "We watched over them, keeping their urine from going on the floor."
    },
    "122": {
        "startTime": 800.8,
        "endTime": 802.0,
        "transcript": "She said that…",
        "translation": "She said that…"
    },
    "123": {
        "startTime": 803.4,
        "endTime": 807.0,
        "transcript": "Wiinga-gguq aanama piqarraallemni ikayullruanga",
        "translation": "Say that my mother helped me when I first [gave birth]"
    },
    "124": {
        "startTime": 807.1,
        "endTime": 816.0,
        "transcript": "Tau͡gaam irnillma kinguani, irnilua ataucirqumek aanama ikayullruanga ciuqlikacaarmek.",
        "translation": "But after I gave birth, my mother helped me once with the eldest."
    },
    "125": {
        "startTime": 818.4,
        "endTime": 824.0,
        "transcript": "Tua-i-llu kinguani irniqataama tungiinek",
        "translation": "And afterwards, when I was going to give birth to the next one"
    },
    "126": {
        "startTime": 824.5,
        "endTime": 831.0,
        "transcript": "Ikani Mamterillermiupiallerni ikegkuni misviim nunallrani",
        "translation": "Across there in the original Bethel where the landing strip was"
    },
    "127": {
        "startTime": 831.9,
        "endTime": 835.0,
        "transcript": "Tungiinek ciuqliim irniama irnillruunga.",
        "translation": "I gave birth to the second of my eldest."
    },
    "128": {
        "startTime": 835.7,
        "endTime": 838.4,
        "transcript": "Nallunritua anqatallranek.",
        "translation": "I knew that [s]he was going to be born."
    },
    "129": {
        "startTime": 839.9,
        "endTime": 849.5,
        "transcript": "Nallunrilama-llu uptellruunga acikiurlua tua-i irnikuma cururkamnek.",
        "translation": "Because I knew, I prepared a mat for when I gave birth."
    },
    "130": {
        "startTime": 850.0,
        "endTime": 861.5,
        "transcript": "Acikiurlua upqaarlua kiagmi piama July-ami, July 6-aami aipirilua irnillemnek.",
        "translation": "After I prepared a mat because it was in the summer, in July, I gave birth a second time on July 6."
    },
    "131": {
        "startTime": 864.8,
        "endTime": 871.2,
        "transcript": "Tua-i-llu piama upqaarlua nuussicuagnek pilua",
        "translation": "And then when I was [in labor] after I prepared, I took out scissors"
    },
    "132": {
        "startTime": 871.3,
        "endTime": 876.0,
        "transcript": "Tangvallruamku aanaka ciuqlirmi irnillemni aulukillra.",
        "translation": "Because I watched how my mother took care of it when I first gave birth."
    },
    "133": {
        "startTime": 876.4,
        "endTime": 882.0,
        "transcript": "Nuussicuagnek paivcilua yualukamek-llu qillrutarkagnek.",
        "translation": "I set out scissors and thread to tie be tied."
    },
    "134": {
        "startTime": 883.0,
        "endTime": 888.0,
        "transcript": "Tua-i-llu tauna mikelnguq anngan wangnek aulukluku.",
        "translation": "And then when that child was born, I took care of it myself."
    },
    "135": {
        "startTime": 890.5,
        "endTime": 895.5,
        "transcript": "Qallacia, uskuraa man'a, ingna-w' iqua.",
        "translation": "[Here was] the belly button, umbilical cord here, and the end over there."
    },
    "136": {
        "startTime": 895.6,
        "endTime": 899.5,
        "transcript": "Anngan uuggun qillerrluku, uuggun-llu qillerrluku.",
        "translation": "When [s]he was born, I tied it, and tied it here."
    },
    "137": {
        "startTime": 900.0,
        "endTime": 903.0,
        "transcript": "Qukaagnegun-llu nuussicuarluku kepluku.",
        "translation": "And then I cut it with scissors in the middle."
    },
    "138": {
        "startTime": 903.5,
        "endTime": 905.8,
        "transcript": "Tua-i wangnek aulukurallruanka",
        "translation": "I took care of them myself"
    },
    "139": {
        "startTime": 906.0,
        "endTime": 916.4,
        "transcript": "Ukut tau͡gaam tua-i cetaman piani anellret qulem cipneri, ten-aam cipneri ukut waniw' 14-aarqunek pillruama",
        "translation": "But these four after the ten, qulem cipneri, because I [gave birth] 14 times"
    },
    "140": {
        "startTime": 916.5,
        "endTime": 919.0,
        "transcript": "Mat'umek qanemcitamci.",
        "translation": "I'm telling you this story."
    },
    "141": {
        "startTime": 920.0,
        "endTime": 928.0,
        "transcript": "What [?]. Did you understand? [?]",
        "translation": "What [?]. Did you understand? [?]"
    },
    "142": {
        "startTime": 929.8,
        "endTime": 933.0,
        "transcript": "…ilait-wa piniatelaameng arnat.",
        "translation": "…because some women are weak."
    },
    "143": {
        "startTime": 934.0,
        "endTime": 939.6,
        "transcript": "Tamaani allamek arnamek nunameggni pitaitaqan",
        "translation": "Back then, when there was no other woman in the village."
    },
    "144": {
        "startTime": 941.0,
        "endTime": 944.9,
        "transcript": "Kiimeng, kiimenatek piaqamek ikayuqlutek.",
        "translation": "When they2 [delivered a child] by themselves2, they2 helped each other."
    },
    "145": {
        "startTime": 945.0,
        "endTime": 952.0,
        "transcript": "Uum uingan tua-i tamakut qallaciit qillerrluki kepluki-llu.",
        "translation": "Her husband would tie their umbilical cords and cut them."
    },
    "146": {
        "startTime": 953.9,
        "endTime": 959.4,
        "transcript": "Arnaq canimelkemeggni pitangqerraqan",
        "translation": "When there was a women close to them"
    },
    "147": {
        "startTime": 959.5,
        "endTime": 965.0,
        "transcript": "Taum aipaan kel'tua tauna aipani piniluku nayuusqelluku.",
        "translation": "Her husband invites here, telling her that his wife [is in labor] and for her to be with [his wife]."
    },
    "148": {
        "startTime": 965.5,
        "endTime": 974.0,
        "transcript": "Tua-i allam arnam tua-i ikayutuluku tauna wii nallunritlemni tua-i tamaani.",
        "translation": "Another woman would help her from what I know of back then."
    },
    "149": {
        "startTime": 975.0,
        "endTime": 983.9,
        "transcript": "Aipaan tau͡gken tua-i ikayurtekailami ikayurtaqaitaqamek, ellminek piyugnganritaqan",
        "translation": "However, because her husband has no help when they have none, when she can't do it herself"
    },
    "150": {
        "startTime": 984.0,
        "endTime": 987.4,
        "transcript": "Aipaan ikayutuluku irniaqan.",
        "translation": "Her husband helps her deliver the baby."
    },
    "151": {
        "startTime": 988.4,
        "endTime": 991.9,
        "transcript": "Au͡gna tua-i waten ayuquq.",
        "translation": "This is what that's like."
    },
    "152": {
        "startTime": 992.0,
        "endTime": 1004.0,
        "transcript": "Tua-ll' cali mikelnguut kenkiyaraatnek cali ilii waten ayuquq:",
        "translation": "And then part of loving children is like this:"
    },
    "153": {
        "startTime": 1005.9,
        "endTime": 1014.5,
        "transcript": "Mikelnguq tua-i maktesciigataqami camek elitnaullerkaa nallunalartuq",
        "translation": "When a child can't get up, his teachings are unintelligible"
    },
    "154": {
        "startTime": 1015.0,
        "endTime": 1020.5,
        "transcript": "Camek-llu qanrut'nge'rmi taringyuunani, taringyaurteksaunani.",
        "translation": "And even though [s]he is told, [s]he doesn't understand, isn't yet able to understand."
    },
    "155": {
        "startTime": 1021.0,
        "endTime": 1028.5,
        "transcript": "Nutaan-llu tua-i makcan temii pinirian, makcan, aqumgayaurcan",
        "translation": "And when he finally wakes up and his body is strengthened, wakes up, starting to sit"
    },
    "156": {
        "startTime": 1030.5,
        "endTime": 1038.0,
        "transcript": "Nutaan aarnarqellriit elliinun cali waten estuulumi ner'aqameng uuqnarqellriit",
        "translation": "These things dangerous to him, how things on the table when they eat"
    },
    "157": {
        "startTime": 1039.8,
        "endTime": 1045.0,
        "transcript": "Tua-i tauna uuqitlerkaa nalluagu taum mikelnguum",
        "translation": "Because that child doesn't know that [s]he will get burned"
    },
    "158": {
        "startTime": 1046.0,
        "endTime": 1052.0,
        "transcript": "Elliinun mikelngurmun agtuq'ertelluku tauna uuqnarqellria.",
        "translation": "Have that child briefly touch that hot thing."
    },
    "159": {
        "startTime": 1052.3,
        "endTime": 1060.0,
        "transcript": "Tua-i-llu kinguani pirraarluku naspaaluku taumek imumun agturcetaaruarluku",
        "translation": "And then after that, try to have him touch that [hot thing]"
    },
    "160": {
        "startTime": 1060.5,
        "endTime": 1067.0,
        "transcript": "Ak'a tua-i eligarrluku imum mikelnguum. Uuqnarqucia tauna nallunriqerrluku.",
        "translation": "That child will have already learned. [S]he will know that it's hot."
    },
    "161": {
        "startTime": 1068.0,
        "endTime": 1073.2,
        "transcript": "Tua-i-gguq uuqitlerkaa man'a nallumini qaillun pikan",
        "translation": "They say that should they somehow get accidently burned"
    },
    "162": {
        "startTime": 1073.3,
        "endTime": 1077.0,
        "transcript": "Uuqnarqellria taun' taum tua-i nallunrirluku.",
        "translation": "[S]he will know that it's hot [and avoid it]."
    },
    "163": {
        "startTime": 1078.0,
        "endTime": 1086.0,
        "transcript": "Waten elpengcuaralriatun ayuqelaameng aqumgayaurtaqameng",
        "translation": "Because it's like they are gradually learning when they start sitting."
    },
    "164": {
        "startTime": 1087.0,
        "endTime": 1090.5,
        "transcript": "Neryaurtaqameng-llu nerqelluki piaqameng",
        "translation": "And when they start feeding them when they start eating"
    },
    "165": {
        "startTime": 1091.5,
        "endTime": 1096.0,
        "transcript": "Tua-i tamakunek elicungcaaralaraa tauna irniani.",
        "translation": "[A parent] teaches their child about those."
    },
    "166": {
        "startTime": 1097.8,
        "endTime": 1109.0,
        "transcript": "Cali-llu tua-i camek pian cali mat'umek teguyullranek inerqurluku cali.",
        "translation": "Also admonish him against grabbing these various things."
    },
    "167": {
        "startTime": 1109.5,
        "endTime": 1114.8,
        "transcript": "Tua-i tegularcetevkenaku, elliinun teguyugcetevkenaku.",
        "translation": "Don't let him grab things, and don't give him things to grab."
    },
    "168": {
        "startTime": 1115.5,
        "endTime": 1121.4,
        "transcript": "Tamaa-i-am-gguq teguyugtelluku mikelnguq anglica'arqami",
        "translation": "They say that when a child grows up being allowed to grab things"
    },
    "169": {
        "startTime": 1121.5,
        "endTime": 1130.5,
        "transcript": "Tua-i teguqailitavkarluku tua-i makunek tua-i anglicuariimi",
        "translation": "Allowing him to grab these [various] things as he grows up"
    },
    "170": {
        "startTime": 1132.0,
        "endTime": 1143.5,
        "transcript": "Angliami pinariami cali tamakunek teguyullerminek imkunek caperqenrirluki.",
        "translation": "When he grows up and he is able, he has no reservations about taking things."
    },
    "171": {
        "startTime": 1144.5,
        "endTime": 1148.5,
        "transcript": "Tua-i yuum-llu pia teguyukuniu teguyugngaluku",
        "translation": "[S]he can also take another person's possession when [s]he wants."
    },
    "172": {
        "startTime": 1149.0,
        "endTime": 1157.0,
        "transcript": "Ak'a tua-i tamaani piveknani, inerquumavkenani teguyugtaciatun piyugtaciatun pivkarluku.",
        "translation": "Because [s]he was not admonished, being allowed to take whatever [s]he wanted whenever [s]he wanted."
    },
    "173": {
        "startTime": 1157.7,
        "endTime": 1166.4,
        "transcript": "Tua-i tau͡gaam tuani piqarraami inerquulluki tamakut pikuniki",
        "translation": "However, when [s]he is admonished against those from the beginning"
    },
    "174": {
        "startTime": 1167.0,
        "endTime": 1171.0,
        "transcript": "Tua-i-am tuaten cali elitkanirluni.",
        "translation": "[S]he will also learn like that."
    },
    "175": {
        "startTime": 1172.0,
        "endTime": 1177.0,
        "transcript": "Cali tua-i taringecuaryaurcan nutaan, taringyaurcan mikelnguq",
        "translation": "Also, when [s]he starts understanding [words], when the child starts understanding"
    },
    "176": {
        "startTime": 1177.7,
        "endTime": 1183.0,
        "transcript": "Qanllemteńek wangkuta taringyaurcan anglikanian",
        "translation": "When [s]he starts understanding what we say as [s]he grows a little"
    },
    "177": {
        "startTime": 1184.0,
        "endTime": 1192.0,
        "transcript": "Qanruyutengqertukut wangkuta anglicartemteńek waten, waten-gguq irniangekumta:",
        "translation": "We have traditional wisdom from those who raised us for when we have children like this:"
    },
    "178": {
        "startTime": 1193.0,
        "endTime": 1199.9,
        "transcript": "Mikelnguq-gguq unuakumi tupakarraaraqami ellangqelartuq.",
        "translation": "A child is aware when [s]he first wakes up."
    },
    "179": {
        "startTime": 1201.0,
        "endTime": 1206.5,
        "transcript": "Tua-i akusrartevkenani makluni, aaravkenani, engelallagavkenani",
        "translation": "[S]he isn't unruly when waking up, not shouting, not laughing"
    },
    "180": {
        "startTime": 1207.0,
        "endTime": 1210.5,
        "transcript": "Tau͡gaam nepaunani, ellangqerrluni-gguq tua-i.",
        "translation": "But quite, because they say they are aware."
    },
    "181": {
        "startTime": 1211.7,
        "endTime": 1222.5,
        "transcript": "Tua-i-gguq tuani nutaan ellangqellrani, nutaan qanruyutmek qanrutecuaqaqluku piluku.",
        "translation": "They say that when he is aware, we should then tell him some traditional wisdom."
    },
    "182": {
        "startTime": 1223.0,
        "endTime": 1231.5,
        "transcript": "Tua-i-gguq ellangqellermini tuani tauna qanruyutni murilkekuniu",
        "translation": "They say that when they are aware and focus on traditional wisdom."
    },
    "183": {
        "startTime": 1233.2,
        "endTime": 1238.0,
        "transcript": "Imkunek-am qanlalriakut iliini, “Tang ellangartelliniuq.”",
        "translation": "They sometimes tell us, “Look, [s]he's suddenly aware.”"
    },
    "184": {
        "startTime": 1238.1,
        "endTime": 1241.5,
        "transcript": "Waten uitanqegcinga'arrluteng piaqata mikelnguut,",
        "translation": "When these children are suddenly quiet like this,"
    },
    "185": {
        "startTime": 1241.6,
        "endTime": 1245.0,
        "transcript": "“Ellanga'rtuq,” atauciq tangvanga'arrluku.",
        "translation": "“[S]he suddenly aware,” watching one thing."
    },
    "186": {
        "startTime": 1245.7,
        "endTime": 1248.0,
        "transcript": "Tua-i-gguq tuaten ayuquq.",
        "translation": "They day that's what it's like."
    },
    "187": {
        "startTime": 1248.8,
        "endTime": 1253.8,
        "transcript": "Tauna mikelnguq qanruskuni ellangqellriacetun",
        "translation": "If that child is spoken to like someone older"
    },
    "188": {
        "startTime": 1254.0,
        "endTime": 1258.8,
        "transcript": "Imna-llu-gguq nalluyagutevkenaku umyuaqenruluku.",
        "translation": "[S]he will not forget it and remember it more clearly."
    },
    "189": {
        "startTime": 1259.0,
        "endTime": 1263.5,
        "transcript": "Tua-i tau͡gaam uitaqerluni atatakuani qanruyut'mi kinguani.",
        "translation": "But [s]he is more still later after being told traditional wisdom."
    },
    "190": {
        "startTime": 1264.0,
        "endTime": 1269.5,
        "transcript": "Tua-i wangkuta-ll' tupa'agqamta pek'ngartelartukut tua-i cek'varrluta-llu.",
        "translation": "We also start moving about and [doing things] when we wake up."
    },
    "191": {
        "startTime": 1269.6,
        "endTime": 1274.0,
        "transcript": "Tua-i-ll' tauna imna mikelnguq uitanqegcirraarluni",
        "translation": "And then after that child is still"
    },
    "192": {
        "startTime": 1274.5,
        "endTime": 1282.0,
        "transcript": "Nutaan tua-i pek'ngarrluni cali ellani tayim' nalluyaguarrngatellriacetun piluku.",
        "translation": "[S]he starts moving about and is like [s]he's unaware now."
    },
    "193": {
        "startTime": 1283.0,
        "endTime": 1286.0,
        "transcript": "Tua-i-llu anglikanian cali piluku,",
        "translation": "And then when [s]he grows a little more, say to him,"
    },
    "194": {
        "startTime": 1287.0,
        "endTime": 1290.5,
        "transcript": "“Ilan, ilaten kenkurluki ata pikiki.”",
        "translation": "“Now, treat your peers with love.”"
    },
    "195": {
        "startTime": 1290.8,
        "endTime": 1300.3,
        "transcript": "Tua-i waten qanrulluki mat'umek tua-i kenekngamiu, ilain-llu, ilainun-llu kenkisqelluku qanrulluku,",
        "translation": "[A parent] tells him this because they love him, telling him to treat his peers with love,"
    },
    "196": {
        "startTime": 1301.0,
        "endTime": 1305.4,
        "transcript": "“Ilan, ilaten ata kenkurluki unuamek pikina.”",
        "translation": "“Now, treat your peers with love today.”"
    },
    "197": {
        "startTime": 1306.4,
        "endTime": 1314.5,
        "transcript": "Tua-i-gguq taum aaniin wall'u atiin kenekngamiu tuaten cali elluarrluku ayaasqumaluku tamakunun",
        "translation": "They say that because his mother or father loves him, [s]he also wants him to go well [in life] with those [peers]"
    },
    "198": {
        "startTime": 1315.0,
        "endTime": 1321.3,
        "transcript": "Tuaten alerquukarnek cali arcaqanruan kenkurluki ilai pisqelluki.",
        "translation": "Tell them to treat their peers with love because it's the most important instruction."
    },
    "199": {
        "startTime": 1322.0,
        "endTime": 1332.0,
        "transcript": "Tua-llu-gguq call' arnam iliini nakmiin irniaqenrilng'ermiu tauna yuk mikelnguq, yuum allam yua",
        "translation": "And then, they say that someone, even if that child is not her own, someone else's child"
    },
    "200": {
        "startTime": 1333.5,
        "endTime": 1346.0,
        "transcript": "Cali tangerquniu irniamitun imutun pitarrluku cali qanruyutmek cali qanrulluku kenekluku irniamitun pitarrluku.",
        "translation": "When she sees him, she will tell him traditional wisdom as if he were her own, loving him as much as her own children."
    }
};